import {getDurationMinutesText} from 'nutshell-core/get-duration-minutes-text';

export const getSessionDetails = (
    numVisits: number,
    totalVisitDuration: number
): {
    numVisits: number;
    totalVisitDuration: string;
    isUnknownDuration: boolean;
} => {
    if (totalVisitDuration <= 0) {
        return {
            numVisits,
            totalVisitDuration: 'Unknown',
            isUnknownDuration: true,
        };
    }

    const totalVisitDurationText =
        totalVisitDuration < 60
            ? `${totalVisitDuration} second${totalVisitDuration === 1 ? '' : 's'}`
            : getDurationMinutesText(Math.round(totalVisitDuration / 60));

    return {
        numVisits,
        totalVisitDuration: totalVisitDurationText,
        isUnknownDuration: false,
    };
};

export const getPeopleText = (numPeople: number): string | null | undefined => {
    if (!numPeople) return null;

    return numPeople === 1 ? '1 person' : `${numPeople} people`;
};
